// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ce22e911","455":"afe569d5","977":"f0f7b7fb"}[chunkId] + ".chunk.js";
};